var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.57141 0.642857C2.57141 0.642857 2.57141 0 3.21427 0H7.07141C7.07141 0 7.71427 0 7.71427 0.642857V1.92857H2.57141V0.642857Z",
    fill: "#66757F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.85713C0 3.85713 0 1.28571 2.57143 1.28571H20.5714C20.5714 1.28571 23.1429 1.28571 23.1429 3.85713V15.4286C23.1429 15.4286 23.1429 18 20.5714 18H2.57143C2.57143 18 0 18 0 15.4286V3.85713Z",
    fill: "#31373D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16.0714C17.0504 16.0714 19.9286 13.1933 19.9286 9.64287C19.9286 6.09246 17.0504 3.21429 13.5 3.21429C9.94958 3.21429 7.07141 6.09246 7.07141 9.64287C7.07141 13.1933 9.94958 16.0714 13.5 16.0714Z",
    fill: "#CCD6DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14.7857C16.3404 14.7857 18.6429 12.4832 18.6429 9.64286C18.6429 6.80254 16.3404 4.5 13.5 4.5C10.6597 4.5 8.35718 6.80254 8.35718 9.64286C8.35718 12.4832 10.6597 14.7857 13.5 14.7857Z",
    fill: "#31373D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 12.8571C15.2753 12.8571 16.7143 11.418 16.7143 9.64284C16.7143 7.86764 15.2753 6.42856 13.5001 6.42856C11.7249 6.42856 10.2858 7.86764 10.2858 9.64284C10.2858 11.418 11.7249 12.8571 13.5001 12.8571Z",
    fill: "#3B88C3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8929 4.50001C21.4254 4.50001 21.8572 4.06829 21.8572 3.53573C21.8572 3.00317 21.4254 2.57144 20.8929 2.57144C20.3603 2.57144 19.9286 3.00317 19.9286 3.53573C19.9286 4.06829 20.3603 4.50001 20.8929 4.50001Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71427 3.53573C7.71427 4.06866 7.28291 4.50001 6.74998 4.50001H3.5357C3.00277 4.50001 2.57141 4.06866 2.57141 3.53573C2.57141 3.0028 3.00277 2.57144 3.5357 2.57144H6.74998C7.28291 2.57144 7.71427 3.0028 7.71427 3.53573Z",
    fill: "#F5F8FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.1f88eb297a22773155fb2e221b925c8c.svg";
export { ForwardRef as ReactComponent };